// I've no idea what this does or why this is important
export const HelpDeskSymbols = {
    HelpDeskService: Symbol.for("HelpDeskService"),
    HelpDeskProvider: Symbol.for("HelpDeskProvider")
}